/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'
import DeclineIcon from '../../components/elements/DeclineIcon'
import SuccessIcon from '../../components/elements/SuccessIcon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX, faPhone, faPhoneSlash, faEnvelope, faCommentSms } from '@fortawesome/free-solid-svg-icons'
import { selectSubpanelRerender } from '../../redux/rerenderSlice'

function PreferredCommunicationsDashlet({ endpointPath }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)
  const rerenderValue = useSelector((state) => selectSubpanelRerender(state, 'preferred_comm_dashlet'));

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        const m = modules.data.find((e) => e.code_key === 'customer')
        setModule(m)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if ((!requesting.current && endpointPath && row.length === 0) || rerenderValue) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath, rerenderValue])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  const displayIcon = (value) => {
    if (value === 1) {
      return <SuccessIcon />
    } else if (value === 0) {
      return <DeclineIcon />
    } else {
      return '-'
    }
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Communication Preferences</p>
      </div>
      <div className="message-body py-0 px-1">
        {loaded && row && (
          <>
            <div className="columns m-0">
              <div className={`column py-1 px-0 mt-1 ${row.is_home_phone_do_not_call ? 'has-background-danger has-text-info-light' : 'has-background-success'} `}>
                <div className={`py-0`}>
                  <span className="px-3">
                      {row.is_home_phone_do_not_call ? <FontAwesomeIcon icon={faPhoneSlash} className="has-text-white" /> : <FontAwesomeIcon icon={faPhone} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1 has-text-centered">
                    {row.is_home_phone_do_not_call ?
                      <span style={{ fontSize: '14px' }}>Home Phone: Do Not Call</span> :
                      <span>Home Phone</span>}
                  </span>
                </div>
              </div>
              <div className={`column ml-1 py-1 px-0 mt-1 ${row.is_cell_phone_do_not_call ? 'has-background-danger has-text-info-light' : 'has-background-success'} `}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_cell_phone_do_not_call ? <FontAwesomeIcon icon={faPhoneSlash} className="has-text-white" /> : <FontAwesomeIcon icon={faPhone} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {row.is_cell_phone_do_not_call ?
                      <span style={{ fontSize: '14px' }}>Cell Phone: Do Not Call</span> :
                      <span>Cell Phone</span>}
                  </span>
                </div>
              </div>
            </div>
            <div className="columns m-0">
              <div className={`column py-1 px-0 mt-1 ${row.is_work_phone_do_not_call ? 'has-background-danger has-text-info-light' : 'has-background-success'} `}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_work_phone_do_not_call ? <FontAwesomeIcon icon={faPhoneSlash} className="has-text-white" /> : <FontAwesomeIcon icon={faPhone} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {row.is_work_phone_do_not_call ?
                      <span style={{ fontSize: '14px' }}>Work Phone: Do Not Call</span> :
                      <span>Work Phone</span>}
                  </span>
                </div>
              </div>
              <div className={`column ml-1 py-1 px-0 mt-1 ${row.is_do_not_call ? 'has-background-danger has-text-info-light' : 'has-background-success'}`}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_do_not_call ? <FontAwesomeIcon icon={faPhoneSlash} className="has-text-white" /> : <FontAwesomeIcon icon={faPhone} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {row.is_do_not_call ? 'Do Not Call' : 'Calls Allowed'}
                  </span>
                </div>
              </div>
            </div>
            <div className="columns m-0">
              <div className={`column py-1 px-0 mt-1 ${row.is_consent_phone_marketing ? 'has-background-success' : 'has-background-danger has-text-info-light'}`}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_consent_phone_marketing ? <FontAwesomeIcon icon={faPhone} className="has-text-white" /> : <FontAwesomeIcon icon={faPhoneSlash} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {renderHeader('is_consent_phone_marketing')}
                  </span>
                </div>
              </div>
              <div className={`column ml-1 py-1 px-0 mt-1 ${row.is_consent_email_marketing ? 'has-background-success' : 'has-background-danger has-text-info-light'}`}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_consent_email_marketing ? <FontAwesomeIcon icon={faEnvelope} className="has-text-white" /> : <FontAwesomeIcon icon={faX} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {renderHeader('is_consent_email_marketing')}
                  </span>
                </div>
              </div>
            </div>
            <div className="columns m-0">
              <div className={`column py-1 px-0 mt-1 ${row.is_consent_sms_marketing ? 'has-background-success' : 'has-background-danger has-text-info-light'} `}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_consent_sms_marketing ? <FontAwesomeIcon icon={faCommentSms} className="has-text-white" /> : <FontAwesomeIcon icon={faX} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {renderHeader('is_consent_sms_marketing')}
                  </span>
                </div>
              </div>
              <div className={`column ml-1 py-1 px-0 mt-1 ${row.is_consent_email_transactional ? 'has-background-success' : 'has-background-danger has-text-info-light'}`}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_consent_email_transactional ? <FontAwesomeIcon icon={faEnvelope} className="has-text-white" /> : <FontAwesomeIcon icon={faX} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1">
                    {renderHeader('is_consent_email_transactional')}
                  </span>
                </div>
              </div>
            </div>
            <div className="columns m-0 mb-1 is-flex-wrap">
              <div className={`column py-1 px-0 mt-1 ${row.is_consent_sms_transactional ? 'has-background-success' : 'has-background-danger has-text-info-light'}`}>
                <div className={`py-0`}>
                  <span className="px-3">
                    {row.is_consent_sms_transactional ? <FontAwesomeIcon icon={faCommentSms} className="has-text-white" /> : <FontAwesomeIcon icon={faX} className="has-text-white" /> }
                  </span>
                  <span className="lox-dashlet-detail__item__label is-size-8 mr-1 is-half">
                    {renderHeader('is_consent_sms_transactional')}
                  </span>
                </div>
              </div>
              <div className={`column ml-1 py-1 px-0`}>
                <span className={'px-3'}></span>
              </div>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}

export default PreferredCommunicationsDashlet
